import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Catalog } from '@core/models/catalog';
import { DataLayerService } from '@core/services/seo/data-layer.service';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProductCardComponent implements OnInit {
  defaultElevation = 2;
  raisedElevation = 6;
  isFavorite = false;

  @Input() product: Catalog;
  @Input() viewport
  
  constructor(
    private router: Router
    ) { }
    
    ngOnInit(): void {
  }


  toggleFavorite(): void {
    this.isFavorite = !this.isFavorite;
  }

  productDetailPage(product){
      // Store any necessary product data in a service or localStorage if needed
      this.router.navigateByUrl(`catalog/${product.brand}/${product.style}`, {state: product})
      .then(() => {
        // Force a scroll to top after navigation is complete
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      });
  }

    // Function to handle image URLs based on the vendor
    getVendorImageUrl(option: any): string {
      let baseUrl = 'https://img.stokkup.com/app/no-image.png'; // Default URL for images
  
      if (option && option.vendor) {
        if (option.vendor.includes('ssactivewear')) {
          baseUrl = 'https://cdn.ssactivewear.com/';
        } else if (option.vendor.includes('alphabroder')) {
          baseUrl = 'https://www.alphabroder.com/prodimg/large/';
        } else if(option.vendor.includes('sanmar') || option.vendor.includes('AS Colour')) {
          baseUrl = ''
        } else {
          baseUrl = ''
        }
        // Add more conditions for other vendors if needed
      } else {
        baseUrl = ''
      }
      return baseUrl + (option.images[0] || ''); // Append the image name to the base URL
    }

        // Function to handle image URLs based on the vendor
        getVendorImageUrl2(option: any): string {
          // let baseUrl = 'https://img.stokkup.com/app/no-image.png'; // Default URL for images
          let baseUrl = option
      
          if (option) {
            
            if (option.includes('ssactivewear')) {
              baseUrl = option.replace('/Images/Style', ''); // Remove "/Images/Style"
            }
          }
      
          return baseUrl
        }
    

}
